import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class CreateDestinations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Destinations", link: "/destinations" },
        { title: "Create Destinations", link: "#" },
      ],
      destinationName: "",
      selectedTypes: [],
    };
  }

  destinationTypeOptions = [
    { value: "Spiritual", label: "Spiritual" },
    { value: "Leisure", label: "Leisure" },
    { value: "Experiential", label: "Experiential" },
  ];

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleTypeChange = (selectedOptions) => {
    this.setState({ selectedTypes: selectedOptions || [] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { destinationName, selectedTypes } = this.state;

      const response = await fetch(`${config.API_BASE_URL}/destinations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          destination_name: destinationName,
          destination_type: selectedTypes.map((type) => type.value), // send array of values
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Destination created:", data);
        this.props.router.navigate("/destinations");
      } else {
        console.error("Failed to create destination:", data);
        alert(data.message || "Failed to create destination");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error creating destination");
    }
  };


  handleCancel = () => {
    this.props.router.navigate("/destinations");
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Create Destinations"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Destination Name</Label>
                            <Input
                              type="text"
                              name="destinationName"
                              placeholder="Enter Destination Name"
                              value={this.state.destinationName}
                              onChange={this.handleInputChange}
                              required
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Destination Type</Label>
                            <Select
                              isMulti
                              name="destinationTypes"
                              options={this.destinationTypeOptions}
                              value={this.state.selectedTypes}
                              onChange={this.handleTypeChange}
                              placeholder="Select destination types..."
                              isClearable
                              isSearchable
                              classNamePrefix="react-select"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-4">
                        <Col className="d-flex justify-content-end">
                          <Button type="submit" color="primary" className="me-2">
                            Create Destination
                          </Button>
                          <Button
                            type="button"
                            color="secondary"
                            onClick={this.handleCancel}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(CreateDestinations);